export default {
  SCHOOLS_FETCH_START: 'SCHOOLS_FETCH_START',
  SCHOOLS_FETCH_SUCCESS: 'SCHOOLS_FETCH_SUCCESS',
  SCHOOLS_FETCH_FAILURE: 'SCHOOLS_FETCH_FAILURE',
}
